module.exports = __webpack_public_path__ + "static/img/5.4baaf3a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/5.png
// module id = FtsW
// module chunks = 0